import * as React from 'react';
import { Outlet } from 'react-router';
import { ReactRouterAppProvider } from '@toolpad/core/react-router';
import type { Navigation } from '@toolpad/core';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import QrCode2Icon from '@mui/icons-material/QrCode2';
import EventNoteIcon from '@mui/icons-material/EventNote';
import DashboardIcon from '@mui/icons-material/Dashboard';
import axios from 'axios';

const NAVIGATION: Navigation = [
  {
    kind: 'header',
    title: 'Main items',
  },
  {
    title: 'Dashboard',
    icon: <DashboardIcon />,
  },
  {
    segment: 'users',
    title: 'Users',
    icon: <ManageAccountsIcon />,
  },
  {
    segment: 'qrcode',
    title: 'QR Code',
    icon: <QrCode2Icon />,
  },
  {
    segment: 'logs',
    title: 'Logs',
    icon: <EventNoteIcon />,
  }
];

const BRANDING = {
  title: 'IDEA Data Whispers',
  homeUrl: '/',
  logo: <img src='https://idea4industry.com/wp-content/uploads/cropped-IDEA-favicon-192x192.png' alt='IDEA Data Whispers' width='32' height='32' />,
};

export default function App() {
  React.useEffect(() => {
    (async () => {
      try {
        const response = await axios.get('/get-logged-in-user/');
        localStorage.setItem('user', response.data.user);
      } catch (error) {
        console.error('Failed to fetch logged-in user:', error);
      }
    })();
  }, []);

  return (
    <ReactRouterAppProvider navigation={NAVIGATION} branding={BRANDING}>
      <Outlet />
    </ReactRouterAppProvider>
  );
}
